<template>
  <div>
    <v-card
      style="
        background-color: transparent;
        border-radius: 15px;
        margin-top: 2vw;
      "
      elevation="1"
    >
      <v-card-text>
        <v-container v-if="loading">
          <v-row dense class="mt-9" alig="center" justify="center">
            <v-progress-circular indeterminate></v-progress-circular>
          </v-row>
        </v-container>
        <v-container v-else>
          <v-row>
            <v-row dense>
              <v-col cols="12" md="4"
                ><span class="text-h5"
                  >{{ module.title }} - {{ module.category }}</span
                ></v-col
              >
              <v-col cols="12" md="2"
                ><v-btn plain @click="goBack()"
                  ><v-icon>mdi-chevron-left</v-icon
                  ><strong style="text-transform: capitalize" class="texth7"
                    >Voltar</strong
                  ></v-btn
                ></v-col
              >
            </v-row>
          </v-row>
          <v-row style="margin-top: 3vw">
            <v-card
              elevation="1"
              class="mx-auto px-auto my-auto py-auto"
              width="100vw"
            >
              <v-card-text>
                <v-row dense>
                  <v-col cols="12" md="12">
                    <span>Conteúdo</span>
                    <v-carousel
                      v-model="carouselIndex"
                      :cycle="false"
                      height="700"
                      hide-delimiters
                      show-arrows-on-hover
                      class="rounded-lg mt-3"
                    >
                      <v-carousel-item
                        v-for="(item, i) in module.content"
                        :key="i"
                        :class="{
                          'content-item-card': true,
                          'video-item': isVideo(item.type),
                        }"
                      >
                        <div
                          class="d-flex align-center px-4 pt-2 content-header"
                        >
                          <h3 class="text-h6 white--text">{{ item.name }}</h3>
                          <v-spacer></v-spacer>
                          <v-chip dark color="primary" class="ma-2">{{
                            getItemTypeLabel(item.type)
                          }}</v-chip>
                          <v-chip dark color="primary"
                            >Visualizando:
                            {{ carouselIndex ? carouselIndex + 1 : 1 }} /
                            {{ module.content.length }}</v-chip
                          >
                        </div>

                        <div
                          class="transparent-content-wrapper fill-height pa-4"
                        >
                          <div v-if="isPDF(item.type)" class="fill-height">
                            <iframe
                              :src="`${item.url}#toolbar=0`"
                              width="100%"
                              height="100%"
                              frameborder="0"
                              allowfullscreen
                            >
                            </iframe>
                          </div>

                          <div v-else-if="isPPT(item.type)" class="fill-height">
                            <iframe
                              :src="googleDocsViewerUrl(item.url)"
                              width="100%"
                              height="100%"
                              frameborder="0"
                              allowfullscreen
                            >
                            </iframe>
                          </div>

                          <div
                            v-else-if="isVideo(item.type)"
                            class="d-flex justify-center align-center fill-height"
                          >
                            <video
                              :width="
                                $vuetify.breakpoint.smAndDown ? '100%' : '800'
                              "
                              height="500"
                              controls
                            >
                              <source :src="item.url" type="video/mp4" />
                              Seu navegador não suporta o elemento de vídeo.
                            </video>
                          </div>
                        </div>
                      </v-carousel-item>
                    </v-carousel>
                  </v-col>
                </v-row>
                <v-row>
                  <v-tabs v-model="tab">
                    <v-tab href="#tab-1"
                      ><span class="text-h7">Descrição</span></v-tab
                    >
                    <v-tab href="#tab-2"
                      ><span class="text-h7">Anotações</span></v-tab
                    >
                    <v-tab href="#tab-3"
                      ><span class="text-h7">Palavras chave</span></v-tab
                    >
                    <v-tabs-items v-model="tab">
                      <v-tab-item value="tab-1">
                        <div>
                          <v-row no-gutters class="mt-4">
                            <v-card
                              elevation="1"
                              style="background-color: transparent; width: 100%"
                            >
                              <v-card-text>
                                <v-row>
                                  <v-col>
                                    <span class="text-h6">
                                      {{ module.description }}
                                    </span>
                                  </v-col>
                                </v-row>
                              </v-card-text>
                            </v-card>
                          </v-row>
                        </div>
                      </v-tab-item>
                      <v-tab-item value="tab-2">
                        <v-card style="background-color: transparent">
                          <v-card-text>
                            <v-row>
                              <v-col>
                                <v-textarea
                                  label="Insira aqui suas anotações e pressione enter para adicionar."
                                  variant="filled"
                                  auto-grow
                                  append-inner-icon="mdi-comment"
                                  rows="2"
                                  class="mx-2"
                                  color="orange orange-darken-4"
                                  @keypress.enter="insertComment"
                                  v-model="comment"
                                >
                                </v-textarea>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col>
                                <v-switch
                                  label="Inverter ordem"
                                  v-model="reverse"
                                ></v-switch>
                                <span class="text-h7"
                                  >Anotações feitas: {{ totalComments }}</span
                                >
                              </v-col>
                            </v-row>
                            <v-row dense class="mt-4">
                              <v-col class="d-flex justify-center">
                                <v-timeline>
                                  <v-timeline-item
                                    v-for="(comment, i) in comments"
                                    :key="i"
                                    small
                                  >
                                    <template v-slot:opposite>
                                      <span
                                        class="headline font-weight-bold grey--text"
                                      >
                                        Anotação feita
                                      </span>
                                    </template>

                                    <div class="note-text">
                                      {{ comment.note }}
                                    </div>
                                  </v-timeline-item>
                                </v-timeline>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-tab-item>
                      <v-tab-item value="tab-3">
                        <v-col cols="12" md="12">
                          <span>Keywords</span>
                          <v-expansion-panels>
                            <v-expansion-panel
                              v-for="(item, i) in module.keywords"
                              :key="i"
                            >
                              <v-expansion-panel-header>
                                {{ item.keyword }}
                              </v-expansion-panel-header>
                              <v-expansion-panel-content>
                                <span class="text-h6">{{
                                  item.description
                                }}</span>
                              </v-expansion-panel-content>
                            </v-expansion-panel>
                          </v-expansion-panels>
                        </v-col>
                      </v-tab-item>
                    </v-tabs-items>
                  </v-tabs>
                </v-row>
              </v-card-text>
            </v-card>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import pitchCustomerApi from "@/shared/pitchCustomerApi";
import { format } from "date-fns";
export default {
  name: "CourseContentPage",
  components: {},
  async created() {
    await pitchCustomerApi
      .getCourseContent(this.$route.params.id)
      .then((res) => {
        this.moduleId = this.$route.params.id;
        this.comments = res.data.notes.notes;
        this.totalComments = res.data.notes.count;
        this.loading = false;
        this.module = res.data.content;
      })
      .catch((err) => {
        console.log(err);
      });
  },
  data() {
    return {
      module: {},
      moduleId: "",
      tab: "tab-1",
      loading: true,
      comments: [],
      totalComments: 0,
      reverse: false,
      comment: "",
      carouselIndex: 0,
    };
  },
  methods: {
    getItemTypeLabel(type) {
      if (this.isPDF(type)) return "PDF";
      if (this.isPPT(type)) return "PPT/Apresentação";
      if (this.isVideo(type)) return "Vídeo";
      return "Conteúdo";
    },
    goBack() {
      this.$router.back();
    },
    googleDocsViewerUrl(url) {
      return `https://docs.google.com/gview?url=${encodeURIComponent(
        url
      )}&embedded=true`;
    },
    insertComment() {
      if (this.comment.trim() === "") return;
      {
        pitchCustomerApi
          .addCourseContentNote(this.moduleId, this.comment)
          .then((res) => {
            this.comments.push(res.data.note);
          });

        this.$root.$emit("display-alert", {
          text: `Comentário adicionado com sucesso!`,
          type: 0,
          timeout: 1500,
        });
      }
      this.comment = "";
    },
    reverseComments() {
      this.reverse = !this.reverse;
    },
    formatDate(date) {
      if (date) return format(date, "dd/MM/yyyy HH:mm");
    },
    isPDF(filename) {
      return filename.includes("pdf");
    },
    isVideo(filename) {
      return filename.includes("mp4");
    },
    isPPT(filename) {
      return (
        filename.includes("presentation") ||
        filename.includes("ppt") ||
        filename.includes("pptx") ||
        filename.includes("powerpoint")
      );
    },
  },
  watch: {
    reverse() {
      this.comments.reverse();
    },
  },
};
</script>

<style lang="css" scoped>
.note-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 400px; /* ajusta conforme o layout */
  font-size: 0.9rem;
  color: #333;
}
</style>
